import { useQuery } from '@apollo/client';
import { createContext, useEffect, useState } from 'react';
import { GET_GLOBAL_CONFIGURATION } from '../services/configurationQueries/configurationService';
import { LinearProgress, ThemeProvider } from '@mui/material';
import { STORAGE_KEYS } from '../shared/constants';
import { getAffiliateFromDomain } from '../shared/helper';
import SessionService from '../services/SessionService';
import theme from '../theme';
import { createTheme } from '@mui/material';
import typography from '../theme/typography';
import NotFound from '../pages/NotFound';
import BacQueryPage from '../pages/BacQueryPage';

const GlobalContext = createContext({});

export const GlobalProvider = props => {
  const [customTheme, setCustomTheme] = useState(theme);
  const { loading, error, data } = useQuery(GET_GLOBAL_CONFIGURATION, {
    variables: { affiliateName: getAffiliateFromDomain() },
  });

  useEffect(() => {
    if (data) {
      SessionService.setItem(
        STORAGE_KEYS.REALM_INFO,
        data?.getGlobalConfig?.realm,
        'session'
      );
    }
    if (data) {
      const customData = JSON.parse(data?.getGlobalConfig?.globalConfig);
      const theme = createTheme({
        palette: customData.palette,
        typography: typography,
      });
      setCustomTheme(theme);
    }
  }, [data]);

  if (loading) {
    return <LinearProgress color="primary" />;
  }
  if (error) {
    let affiliateDnsName = window.location.href.split('/')[2].split('-')[0];
    if (affiliateDnsName == 'localhost:3000' || affiliateDnsName == 'bactpa') {
      let token = window.location.href.split('=')[1];
      return <BacQueryPage token={token} affiliateDnsName={affiliateDnsName} />
    } else {
      return <NotFound />;
    }
  }
  return (
    <ThemeProvider theme={customTheme}>
      <GlobalContext.Provider
        value={JSON.parse(data.getGlobalConfig.globalConfig)}>
        {props.children}
      </GlobalContext.Provider>
    </ThemeProvider>
  );
};

export default GlobalContext;
